module.exports = __webpack_public_path__ + "static/media/voertuig@3x.12e2cd0b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/02/02/assets/voertuig@3x.svg
// module id = 438
// module chunks = 0